import computeClassName from "../../../../../../utils/computeClassName";

const constants = Object.freeze({
  CLASSNAME_BASE: 'block w-full appearance-none focus:outline-none focus-visible:outline-none bg-transparent',
  CLASSNAME_IS_DISABLED: {
    true: 'font-semibold text-cc-muted-contrast placeholder-cc-muted-contrast',
    false: 'font-semibold text-cc-primary-contrast placeholder-cc-gray-80'
  },
});

function getComputedClassName(propsClassName, isDisabled) {
  return computeClassName(propsClassName, `${constants.CLASSNAME_BASE} ${constants.CLASSNAME_IS_DISABLED[isDisabled]}`);
}

function handleEvent(fn) { return (e) => { fn(e.target.value); } }

export default function CCFormInputInput(
  {
    id,
    name,
    placeholderText,
    value,
    type,
    isDisabled,
    changeFn,
    focusFn,
    blurFn,
    className
  }) {
  const computedClassName = getComputedClassName(className, isDisabled);

  let dynamicProps = {};

  if (!!type && !!type.length) dynamicProps['type'] =type;
  if (!!id && !!id.length) dynamicProps['id'] = id;
  if (!!name && !!name.length) dynamicProps['name'] = name;
  dynamicProps['value'] = !!value ? value: '';
  if (!!placeholderText && !!placeholderText.length) dynamicProps['placeholder'] = placeholderText;
  if(!isDisabled) {
    if (!!changeFn && ('function' === typeof changeFn)) {
      dynamicProps['onChange'] = handleEvent(changeFn);
    }
    if (!!focusFn && ('function' === typeof focusFn)) {
      dynamicProps['onFocus'] = handleEvent(focusFn);
    }
    if (!!blurFn && ('function' === typeof blurFn)) {
      dynamicProps['onBlur'] = handleEvent(blurFn);
    }
  }
  else {
    dynamicProps['disabled'] = true;
    dynamicProps['aria-disabled'] = true;
  }

  return <input className={computedClassName} {...dynamicProps}/>;
}
